import type { Conversation, Message } from '../types';

export class ApiClient {
  private apiUrl: string;
  private apiKey: string;

  constructor(apiUrl: string, apiKey: string) {
    this.apiUrl = apiUrl.replace(/\/$/, ''); // Remove trailing slash
    this.apiKey = apiKey;
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': this.apiKey,
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return data.data || data;
  }

  async createConversation(appId: string, userId?: string, title?: string): Promise<Conversation> {
    return this.request<Conversation>(`/apps/${appId}/chat/conversations`, {
      method: 'POST',
      body: JSON.stringify({ userId, title }),
    });
  }

  async getConversation(appId: string, conversationId: string): Promise<Conversation & { messages: Message[] }> {
    return this.request<Conversation & { messages: Message[] }>(
      `/apps/${appId}/chat/conversations/${conversationId}`
    );
  }

  async sendMessage(
    appId: string,
    conversationId: string,
    content: string
  ): Promise<{ userMessage: Message; assistantMessage: Message }> {
    return this.request<{ userMessage: Message; assistantMessage: Message }>(
      `/apps/${appId}/chat/conversations/${conversationId}/messages`,
      {
        method: 'POST',
        body: JSON.stringify({ content }),
      }
    );
  }

  async getWidgetConfig(): Promise<{
    active: boolean;
    config: any;
    appearance: any;
  }> {
    return this.request<{
      active: boolean;
      config: any;
      appearance: any;
    }>('/widget/config');
  }
}

